module.exports = __webpack_public_path__ + "img/farming_12.00ba5246.png";